import { Injectable } from '@angular/core';
import { HttpRequest, HttpParams } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
@Injectable({
  providedIn: 'root'
})
export class MockService {
  private filePath = '';
  private cnt = 0;

  constructor(private env: EnvironmentService) {

  }

  /**
   * Return mock request in case URL or .JSON file match.
   * @param req : Origin request
   */
  getMockRequest() :HttpRequest<any>{
    return new HttpRequest("GET",this.filePath);
  }

  /**
   * Prepare mock URL for configured REST API(Mock-1) or .JSON files(Mock-2)
   * @param url : URL from origin request
   */
  isMockUrlExists(url: string, params?: HttpParams):boolean{
    this.filePath = window.location.origin;
    let isUrl = true;
    /* if(url.endsWith('/auth/login')){
      //Mock-1: REST API based on url
      this.filePath += '/assets/mock/login.json';
    }else  if(url.endsWith('/rest/engine/default/group')){
      this.filePath += '/assets/mock/bps/user-group.json';
    }else if(url.endsWith('/rest/engine/default/task')){
      if(params !== undefined && params.get('assignee') === 'root'){
        this.filePath += '/assets/mock/bps/tasklist.json';
      }else{
        this.filePath += '/assets/mock/bps/tasklist.1.json';
      }
    }else if(url.endsWith('/complete')){
      this.filePath += '/assets/mock/bps/tasklist.json';
    }else if(url.endsWith('/variables')){
      this.filePath += '/assets/mock/bps/task-variables'+(this.cnt%2)+'.json';
      this.cnt++;
    }else */if(url.endsWith('.json')){
      // Mock-2: local .json files
      url = url.replace(this.env.getEnvironment().baseUrl, window.location.origin);
      url = url.replace(this.env.getEnvironment().assetsEndPoint, '');
      this.filePath = url;
    }else{
      isUrl = false;
    }
    return  isUrl;
  }

}
